module.exports = __webpack_public_path__ + "36f9496e16eecc32b92f21040d803cfd.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/es.json
// module id = 1082
// module chunks = 0